import { toTitleCase } from 'utils'
import RoundedIcon from './RoundedIcon'

interface RoundedItemProps {
  className?: string
  defaultImage?: boolean
  imageURL?: string
  titleCase?: boolean
  hasTitle?: boolean
  roundedIconClassName?: string
  name: string
}

// this is a workaround for credit profile institutions response
const DEFAULT_BANK_IMG =
  'https://wm-wallet-public.s3.sa-east-1.amazonaws.com/credit-profile/defaultBankImg.png'

const RoundedItem = ({
  name,
  imageURL,
  className = '',
  titleCase = true,
  roundedIconClassName = '',
  hasTitle = true
}: RoundedItemProps) => {
  const initials = name.split(' ')

  const defaultImageText =
    initials.length > 1
      ? `${initials[0][0]}${initials[1][0]}`.toUpperCase()
      : initials[0].slice(0, 2).toUpperCase()

  // the second part of the condition is a workaround for credit profile institutions.
  // it checks if api is sending a default image
  const defaultImage = !imageURL || imageURL.includes(DEFAULT_BANK_IMG)

  const image = defaultImage ? (
    <p className='text-white font-bold text-xl'>{defaultImageText}</p>
  ) : (
    <img src={imageURL} alt='' />
  )

  return (
    <div
      className={`flex items-center flex-col text-center gap-2 ${className}`}
    >
      <RoundedIcon
        className={`!bg-gray-900 !w-12 !h-12 align-middle ${roundedIconClassName}`}
        icon={image}
      />
      {hasTitle && (
        <p className='text-2xs font-medium text-black truncate max-w-[60px]'>
          {titleCase ? toTitleCase(name) : name}
        </p>
      )}
    </div>
  )
}

export default RoundedItem
